import PitchUploadedStats from './PitchUploadedStats';
import PopularCountryStats from './PopularCountryStats';
import PopularInsightsStats from './PopularInsightsStats';
import PopularRegionStats from './PopularRegionStats';
import PopularTopicsStats from './PopularTopicsStats';
import TotalCompaniesStats from './TotalCompaniesStats';

function CompaniesGraphs() {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <TotalCompaniesStats />
      <PitchUploadedStats />
      <PopularCountryStats />
      <PopularInsightsStats />
      <PopularTopicsStats className="md:col-span-2" />
      <PopularRegionStats className="md:col-span-2" />
    </div>
  );
}

export default CompaniesGraphs;
